import { Button, Card, CardActions, CardBody, CardHeader, CardTitle, IconButton, InfoBox, Modal } from "capitalroadkit";
import { faTimes } from "@fortawesome/pro-regular-svg-icons/faTimes";
import React, { cloneElement, useEffect, useState } from "react";
import { Form, FormikProvider, useFormik } from "formik";
import { updateCorporateActionActivityAxios } from "../../../../api/CorporateActionActivitiyResource";
import useAPI from "../../../../../../hooks/useAPI";
import ActivityForm from "../../../../forms/ActivityForm";
import ActivityType from "../../../../../../types/corporateActions/Activities/ActivityType";

const UpdateActivityModal = ({ button, activity, refreshAPI }) => {
  const [open, setOpen] = useState(false);
  const [schema, setSchema] = useState(ActivityForm.schema);

  const updateActivityAPI = useAPI(updateCorporateActionActivityAxios(activity.uuid), { immediate: false });

  const updateActivityForm = useFormik({
    initialValues: ActivityForm.initialValues(activity, ActivityType.INCOME_ACTIVITY),
    onSubmit: (values) => updateActivityAPI.fetch({}, ActivityForm.clean(values)),
    validationSchema: schema,
    enableReinitialize: true,
  });

  useEffect(() => {
    const { response, loading } = updateActivityAPI;

    if (response && !loading) {
      refreshAPI.fetch();
      updateActivityForm.resetForm();
      setOpen(false);
      updateActivityAPI.reset();
    }
  }, [updateActivityAPI.response, updateActivityAPI.loading]);

  return (
    <>
      {button && cloneElement(button, { onClick: () => setOpen(true) })}
      <Modal open={open}>
        <Card>
          <CardHeader>
            <CardTitle>Update activity</CardTitle>
            <CardActions>
              <IconButton
                icon={faTimes}
                onClick={() => {
                  setOpen(false);
                  updateActivityForm.resetForm();
                  updateActivityAPI.reset();
                }}
              />
            </CardActions>
          </CardHeader>
          <CardBody>
            <FormikProvider value={updateActivityForm}>
              <Form>
                <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                  <ActivityForm form={updateActivityForm} setSchema={setSchema} activity={activity} />
                  {updateActivityAPI.error && (
                    <InfoBox variant={InfoBox?.Variant.ERROR} value={updateActivityAPI.error.response?.data} />
                  )}
                  <div style={{ display: "flex", justifyContent: "end", gap: "8px" }}>
                    <Button
                      color="warning"
                      disable={updateActivityAPI.loading}
                      onClick={() => {
                        updateActivityForm.resetForm();
                        setOpen(false);
                      }}
                    >
                      Cancel
                    </Button>
                    <Button color="primary" loading={updateActivityAPI.loading} type="submit">
                      Update
                    </Button>
                  </div>
                </div>
              </Form>
            </FormikProvider>
          </CardBody>
        </Card>
      </Modal>
    </>
  );
};

export default UpdateActivityModal;
